/**
 * 雷射筆（NBK-1676）
 *
 * 暫時性畫記：放開後自動淡出消失，不寫入畫記紀錄、不進 IndexedDB、不上雲。
 * 繪製在獨立的 overlay canvas 上，與 fabric 主畫布完全隔離，
 * 因此 fabric 的 mouse:up → CanvasFinishPaintingEvent → saveCanvasJSON 這條鏈
 * 從頭到尾不會被觸發。
 */

/** 放開後完整淡出所需時間（毫秒）。規格：0.8 秒內完全消失。 */
export const LASER_FADE_DURATION = 800;

/**
 * 中央白芯佔整體線寬的比例。
 * 彩色描一次（寬 W）、白色再描一次（寬 W * 此比例），
 * 兩描共用同一條中心線，白芯自然置中，兩側各露出 (W - W*ratio)/2 的彩色邊。
 */
export const LASER_WHITE_CORE_RATIO = 0.45;

/** 白芯顏色，不隨使用者選色改變（規格：切換顏色後中央白色不變）。 */
export const LASER_CORE_COLOR = '#ffffff';

/**
 * 首次使用的預設值。
 * 顏色：橘紅色。
 * 粗細：線條粗細選單由上到下數的第四個選項（選單值為 1..14，故為 4）。
 */
export const LaserPenDefaults = {
  colorHex: '#ff4500',
  lineWidth: 12
};
